// Charles feature flags.
//
// Flags default to ON across dev/preview/prod, but can be force-flipped via
// VITE_CHARLES_FLAGS env var (comma-separated `key=on|off` pairs) or via
// localStorage key `charles:flags` (same shape) for fast in-browser rollback.

export type CharlesFlagKey = 'charles_warm_greeting_v1';

const DEFAULTS: Record<CharlesFlagKey, boolean> = {
  charles_warm_greeting_v1: true,
};

function parseOverrides(raw: string | null | undefined): Partial<Record<CharlesFlagKey, boolean>> {
  if (!raw) return {};
  const out: Partial<Record<CharlesFlagKey, boolean>> = {};
  for (const pair of raw.split(',')) {
    const [k, v] = pair.split('=').map((s) => s?.trim());
    if (!k) continue;
    out[k as CharlesFlagKey] = v?.toLowerCase() === 'off' ? false : true;
  }
  return out;
}

export function isCharlesFlagOn(key: CharlesFlagKey): boolean {
  const envOverrides = parseOverrides(import.meta.env.VITE_CHARLES_FLAGS as string | undefined);
  let lsOverrides: Partial<Record<CharlesFlagKey, boolean>> = {};
  try {
    if (typeof window !== 'undefined') {
      lsOverrides = parseOverrides(window.localStorage.getItem('charles:flags'));
    }
  } catch {
    // SSR / privacy mode — ignore
  }
  if (key in lsOverrides) return !!lsOverrides[key];
  if (key in envOverrides) return !!envOverrides[key];
  return DEFAULTS[key];
}
